module.exports = __webpack_public_path__ + "static/media/applied.da68ddc9.svg";